import(/* webpackMode: "eager" */ "/frontend/src/app/[lang]/[currency]/(chrome)/contact/page.tsx")